/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountSubType {
  Association = "Association",
  Athlete = "Athlete",
  Brand = "Brand",
  Business = "Business",
  ContentCreator = "ContentCreator",
  EventOrganizer = "EventOrganizer",
  FanPage = "FanPage",
  Gym = "Gym",
  Host = "Host",
  League = "League",
  PodcastHost = "PodcastHost",
  Shop = "Shop",
  SocialPage = "SocialPage",
  Team = "Team",
}

export enum AccountType {
  Basic = "Basic",
  Creator = "Creator",
}

export enum AffiliateSaleStatus {
  Paid = "Paid",
  Pending = "Pending",
  Refunded = "Refunded",
}

export enum AffiliateSaleType {
  Ppv = "Ppv",
  Tickets = "Tickets",
}

export enum Age {
  Adult = "Adult",
  Youth = "Youth",
}

export enum AiClipCandidateStatus {
  Accepted = "Accepted",
  NotReviewed = "NotReviewed",
  Rejected = "Rejected",
}

export enum AiMerchLogoStyle {
  abstractSymbol = "abstractSymbol",
  boldTypography = "boldTypography",
  emblemBadge = "emblemBadge",
  illustratedGraphic = "illustratedGraphic",
  mascotCharacter = "mascotCharacter",
  minimalLogo = "minimalLogo",
  portraitFace = "portraitFace",
  textGraphic = "textGraphic",
}

export enum AmaOrderBy {
  CreatedAt = "CreatedAt",
  Price = "Price",
  StoreName = "StoreName",
}

export enum AmaOrderStatus {
  Accepted = "Accepted",
  Completed = "Completed",
  Declined = "Declined",
  Pending = "Pending",
  Processing = "Processing",
}

export enum AmaRequestOrderBy {
  CreatedAt = "CreatedAt",
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  DateToResponse = "DateToResponse",
  DiscountAmount = "DiscountAmount",
  Id = "Id",
  Instructions = "Instructions",
  OrderStatus = "OrderStatus",
  Price = "Price",
  ReceiverEmail = "ReceiverEmail",
}

export enum AmaStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum AmaType {
  Ama = "Ama",
  Shoutout = "Shoutout",
}

/**
 * price sorts by Order.subtotal
 */
export enum AnyProductSalesOrderBy {
  createdAt = "createdAt",
  customerEmail = "customerEmail",
  customerName = "customerName",
  rawCreatedAt = "rawCreatedAt",
  status = "status",
  subtotal = "subtotal",
  totalStoreRevenues = "totalStoreRevenues",
  type = "type",
}

export enum ArticleStatus {
  Active = "Active",
  Disabled = "Disabled",
  Draft = "Draft",
  PendingReview = "PendingReview",
}

export enum ArticleStoreOrderBy {
  createdAt = "createdAt",
  status = "status",
}

export enum AuctionStatus {
  Finished = "Finished",
  Live = "Live",
  Scheduled = "Scheduled",
}

export enum AutoGeneratedLogoStatus {
  approved = "approved",
  rejected = "rejected",
}

export enum AutoGeneratedLogoType {
  initials = "initials",
  initialsFlagCenter = "initialsFlagCenter",
  initialsFlagRightSide = "initialsFlagRightSide",
  jersey = "jersey",
  nickname = "nickname",
  signature = "signature",
  signatureBaseball1RightSide = "signatureBaseball1RightSide",
  signatureBaseball2RightSide = "signatureBaseball2RightSide",
  signatureBaseball3RightSide = "signatureBaseball3RightSide",
  signatureBaseball4RightSide = "signatureBaseball4RightSide",
  signatureBasketball1RightSide = "signatureBasketball1RightSide",
  signatureBasketball2RightSide = "signatureBasketball2RightSide",
  signatureBasketball3RightSide = "signatureBasketball3RightSide",
  signatureBasketball4RightSide = "signatureBasketball4RightSide",
  signatureBasketball5RightSide = "signatureBasketball5RightSide",
  signatureBiking1RightSide = "signatureBiking1RightSide",
  signatureBiking2RightSide = "signatureBiking2RightSide",
  signatureBoxing1RightSide = "signatureBoxing1RightSide",
  signatureBoxing2RightSide = "signatureBoxing2RightSide",
  signatureBoxing3RightSide = "signatureBoxing3RightSide",
  signatureFootball1RightSide = "signatureFootball1RightSide",
  signatureFootball2RightSide = "signatureFootball2RightSide",
  signatureFootball3RightSide = "signatureFootball3RightSide",
  signatureFootball4RightSide = "signatureFootball4RightSide",
  signatureFootball5RightSide = "signatureFootball5RightSide",
  signatureFootball6RightSide = "signatureFootball6RightSide",
  signatureFootball7RightSide = "signatureFootball7RightSide",
  signatureGolf1RightSide = "signatureGolf1RightSide",
  signatureGolf2RightSide = "signatureGolf2RightSide",
  signatureHockey2RightSide = "signatureHockey2RightSide",
  signatureHockey3RightSide = "signatureHockey3RightSide",
  signatureHockey4RightSide = "signatureHockey4RightSide",
  signatureHockey5RightSide = "signatureHockey5RightSide",
  signatureHockey6RightSide = "signatureHockey6RightSide",
  signatureMma1RightSide = "signatureMma1RightSide",
  signatureMma2RightSide = "signatureMma2RightSide",
  signatureMma3RightSide = "signatureMma3RightSide",
  signatureMotorracing1RightSide = "signatureMotorracing1RightSide",
  signatureMotorracing2RightSide = "signatureMotorracing2RightSide",
  signatureSkateboarding1RightSide = "signatureSkateboarding1RightSide",
  signatureSkateboarding2RightSide = "signatureSkateboarding2RightSide",
  signatureSoccer1RightSide = "signatureSoccer1RightSide",
  signatureSoccer2RightSide = "signatureSoccer2RightSide",
  signatureSoccer3RightSide = "signatureSoccer3RightSide",
  signatureSoccer4RightSide = "signatureSoccer4RightSide",
  signatureSoccer5RightSide = "signatureSoccer5RightSide",
  signatureSurfing1RightSide = "signatureSurfing1RightSide",
  signatureSurfing2RightSide = "signatureSurfing2RightSide",
  signatureTennis1RightSide = "signatureTennis1RightSide",
  signatureTennis2RightSide = "signatureTennis2RightSide",
}

export enum AutoGeneratedLogosCombinedStatus {
  failed = "failed",
  notReady = "notReady",
  ready = "ready",
}

export enum AutoSocialMediaPackStatus {
  failed = "failed",
  generating = "generating",
  missing = "missing",
  ready = "ready",
}

export enum AutoSocialPackImageStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

export enum BlockType {
  Ban = "Ban",
  Kick = "Kick",
  Mute = "Mute",
  Unmute = "Unmute",
}

export enum CBDeliverableItemType {
  CONFIRMATION = "CONFIRMATION",
  COPY = "COPY",
  FILE = "FILE",
  FILES = "FILES",
  LINK = "LINK",
}

export enum CBDeliverableStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  ON_REVIEW = "ON_REVIEW",
  REJECTED = "REJECTED",
}

export enum CampaignActivityCoveredExpense {
  Flight = "Flight",
  Food = "Food",
  GroundTransportation = "GroundTransportation",
  Hotel = "Hotel",
}

export enum CampaignActivityTargetType {
  SponsoredGuest = "SponsoredGuest",
  SponsoredProduct = "SponsoredProduct",
}

export enum CampaignActivityType {
  Custom = "Custom",
  CustomBrief = "CustomBrief",
  EventMarketing = "EventMarketing",
  InPersonAppearance = "InPersonAppearance",
  Social = "Social",
  SocialBoost = "SocialBoost",
  SocialShare = "SocialShare",
  SponsoredAppearance = "SponsoredAppearance",
  Ugc = "Ugc",
  VirtualAppearance = "VirtualAppearance",
}

export enum CampaignAppearanceType {
  EventAttendance = "EventAttendance",
  MeetAndGreet = "MeetAndGreet",
  OnSiteFilming = "OnSiteFilming",
  Other = "Other",
  Photoshoot = "Photoshoot",
  Signing = "Signing",
  Speaking = "Speaking",
}

export enum CampaignMediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}

export enum CampaignOfferAttention {
  BOTH = "BOTH",
  BRAND = "BRAND",
  TALENT = "TALENT",
}

export enum CampaignOfferGenderFilter {
  NA = "NA",
  female = "female",
  male = "male",
  other = "other",
  preferNotToSay = "preferNotToSay",
}

/**
 * V3
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * DECLINED - Agency declines offer application
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application, acts as IN_PROGRESS
 * EXPIRED - Offer gets expired after application deadline
 * PUBLISHED - All posts are published, Brand needs to complete Deal
 * COMPLETED - Brand approves published artifacts by marking them COMPLETED
 * CANCELLED - Accepted Social Boost deal terminated after a brand dispute (budget refunded, terminal)
 * 
 * V2
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application
 * SCHEDULED - SponsoredAppearance: Talent created stream for Live Appearance
 * DECLINED - Agency declines offer application
 * EXPIRED - Offer gets expired after application deadline
 * SUBMITTED - Talent submitted artifact for Brand to review
 * DELIVERABLES_REJECTED - Brand rejected
 * DELIVERABLES_APPROVED - Talent can publish approved deliverables 
 * PUBLISHED - Talent published artifact
 * COMPLETED - Brand approves published artifacts by marking them COMPLETED
 * 
 * V1
 * PROPOSED - Offers are created but not sent, campaign is not yet paid
 * INVITED - Offer is sent to talent
 * APPLIED - Talent applied for campaign (offer)
 * ACCEPTED - Agency accepts (approves) talent's application
 * SCHEDULED - SponsoredAppearance: Talent created stream for Live Appearance
 * DECLINED - Agency declines offer application
 * EXPIRED - Offer gets expired after application deadline
 * SUBMITTED - Talent published artifacts
 */
export enum CampaignOfferStatus {
  ACCEPTED = "ACCEPTED",
  APPLIED = "APPLIED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  COUNTER_OFFER_PENDING = "COUNTER_OFFER_PENDING",
  DECLINED = "DECLINED",
  DELIVERABLES_APPROVED = "DELIVERABLES_APPROVED",
  DELIVERABLES_REJECTED = "DELIVERABLES_REJECTED",
  EXPIRED = "EXPIRED",
  INVITED = "INVITED",
  PROPOSED = "PROPOSED",
  PUBLISHED = "PUBLISHED",
  SCHEDULED = "SCHEDULED",
  SUBMITTED = "SUBMITTED",
}

export enum CampaignOffersOrderBy {
  appliedAt = "appliedAt",
  approvedAt = "approvedAt",
  avgVote = "avgVote",
  createdAt = "createdAt",
  createdAtPrioritized = "createdAtPrioritized",
  declinedAt = "declinedAt",
  engagementRate = "engagementRate",
  estimatedInfluencerFee = "estimatedInfluencerFee",
  id = "id",
  name = "name",
  socialFollowing = "socialFollowing",
  socialFollowingLive = "socialFollowingLive",
  status = "status",
  submittedAt = "submittedAt",
}

export enum CampaignSmPlatform {
  FB = "FB",
  IG = "IG",
  TT = "TT",
  TW = "TW",
  YT = "YT",
}

export enum CampaignStatus {
  COMPLETED = "COMPLETED",
  DECLINED = "DECLINED",
  DELETED = "DELETED",
  DETAIL_FILLED = "DETAIL_FILLED",
  ON_REVIEW = "ON_REVIEW",
  PAID_AND_ACTIVE = "PAID_AND_ACTIVE",
  PAID_AND_BUDGET_FULFILLED = "PAID_AND_BUDGET_FULFILLED",
}

export enum CampaignTaskType {
  APPEARANCE = "APPEARANCE",
  CONTENT = "CONTENT",
  FB_SHARE = "FB_SHARE",
  FINAL_CONTENT = "FINAL_CONTENT",
  IG_LIVE = "IG_LIVE",
  IG_POST = "IG_POST",
  IG_REEL = "IG_REEL",
  IG_SHARE = "IG_SHARE",
  IG_STORY = "IG_STORY",
  LIVE_APPEARANCE = "LIVE_APPEARANCE",
  RECORDED_APPEARANCE = "RECORDED_APPEARANCE",
  TT_LIVE = "TT_LIVE",
  TT_SHARE = "TT_SHARE",
  TT_STORY = "TT_STORY",
  TT_VIDEO = "TT_VIDEO",
  TW_LIVE = "TW_LIVE",
  TW_SHARE = "TW_SHARE",
  TW_TWEET = "TW_TWEET",
  TW_VIDEO = "TW_VIDEO",
  UGC = "UGC",
  YT_SHARE = "YT_SHARE",
}

export enum CampaignType {
  BookMe = "BookMe",
  Custom = "Custom",
  DirectBooking = "DirectBooking",
  EventMarketing = "EventMarketing",
  Social = "Social",
  SocialBoost = "SocialBoost",
  SocialShare = "SocialShare",
  SponsoredAppearance = "SponsoredAppearance",
  Ugc = "Ugc",
}

export enum CampaignUsageRightsScope {
  AllOtherMedia = "AllOtherMedia",
  PaidMedia = "PaidMedia",
  SocialRepost = "SocialRepost",
  Website = "Website",
  Whitelisting = "Whitelisting",
}

/**
 * Options for interview cancellation
 */
export enum CancellationOption {
  FullCancellation = "FullCancellation",
  InviteToReschedule = "InviteToReschedule",
}

export enum CbApplicationQuestionType {
  Pitch = "Pitch",
  Regular = "Regular",
}

export enum CbDeliverableItemV2Status {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  ON_BRAND_REVIEW = "ON_BRAND_REVIEW",
  REJECTED = "REJECTED",
}

export enum CbDeliverableV2Status {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  CONTENT_APPROVED = "CONTENT_APPROVED",
  CONTENT_REJECTED = "CONTENT_REJECTED",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  ON_BRAND_REVIEW = "ON_BRAND_REVIEW",
  PUBLISHED = "PUBLISHED",
  TALENT_ACTION_NEEDED = "TALENT_ACTION_NEEDED",
}

export enum CbDueDateType {
  APPLICATION_BASED = "APPLICATION_BASED",
  CONTENT_BASED = "CONTENT_BASED",
  FIXED = "FIXED",
  RANGE = "RANGE",
}

export enum CbFixedDateType {
  BEFORE = "BEFORE",
  EXACT = "EXACT",
}

/**
 * Payment source for CB charges: a saved card (off-session) or the account balance
 */
export enum CbPaymentSource {
  ACCOUNT_BALANCE = "ACCOUNT_BALANCE",
  CC = "CC",
}

export enum ChannelMonetizationApplicationStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Review = "Review",
}

export enum ChannelMonetizationMilestoneType {
  Followers = "Followers",
  GuestInvites = "GuestInvites",
  InterviewNow = "InterviewNow",
  InterviewStream = "InterviewStream",
  Mentions = "Mentions",
}

export enum ChannelMonetizationProgramStatus {
  Closed = "Closed",
  Draft = "Draft",
  Open = "Open",
}

export enum ChatChannelScope {
  BrandTalent = "BrandTalent",
  CampaignOffer = "CampaignOffer",
  EventBroadcast = "EventBroadcast",
  EventDirect = "EventDirect",
  Interview = "Interview",
  Support = "Support",
}

export enum ChatChannelState {
  Active = "Active",
  Archived = "Archived",
  Deleted = "Deleted",
  Frozen = "Frozen",
}

export enum ChatProviderChannelType {
  brand_talent = "brand_talent",
  event_broadcast = "event_broadcast",
  event_direct = "event_direct",
  interview = "interview",
  messaging = "messaging",
}

export enum ContactType {
  ATHLETE = "ATHLETE",
  BRAND = "BRAND",
}

export enum CounterOfferAction {
  ACCEPT = "ACCEPT",
  COUNTER = "COUNTER",
  REJECT = "REJECT",
}

export enum CounterOfferProposalStatus {
  ACCEPTED = "ACCEPTED",
  ARCHIVED = "ARCHIVED",
  EXPIRED = "EXPIRED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  SUPERSEDED = "SUPERSEDED",
}

export enum CounterOfferProposedBy {
  ATHLETE = "ATHLETE",
  BRAND = "BRAND",
}

export enum DesignRequestStatus {
  Accepted = "Accepted",
  Archived = "Archived",
  AutoAccepted = "AutoAccepted",
  AwaitingApproval = "AwaitingApproval",
  InProgress = "InProgress",
  OnReview = "OnReview",
  Rejected = "Rejected",
  Todo = "Todo",
}

export enum DesignRequestType {
  LogoAudit = "LogoAudit",
  LogoCreation = "LogoCreation",
  MerchCreation = "MerchCreation",
  MerchCreationWithLogo = "MerchCreationWithLogo",
}

export enum DesignRequestsOrderBy {
  assignDate = "assignDate",
  createdAt = "createdAt",
  designRate = "designRate",
  designRequestId = "designRequestId",
  designRequestType = "designRequestType",
  designerName = "designerName",
  designerStatus = "designerStatus",
  dueDate = "dueDate",
  dueDatePriority = "dueDatePriority",
  status = "status",
  storeName = "storeName",
}

export enum DigitalAgreementPartyStatus {
  Declined = "Declined",
  Pending = "Pending",
  Signed = "Signed",
}

export enum DigitalAgreementSignatureMethod {
  Adopted = "Adopted",
  Provider = "Provider",
}

export enum DigitalAgreementStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Declined = "Declined",
  Expired = "Expired",
  PartiallySigned = "PartiallySigned",
  Pending = "Pending",
}

export enum EventChatSourceType {
  Stream = "Stream",
}

export enum ExperienceOrderBy {
  createdAt = "createdAt",
  price = "price",
  title = "title",
}

export enum ExperienceRequestOrderBy {
  CreatedAt = "CreatedAt",
  CustomerEmail = "CustomerEmail",
  CustomerName = "CustomerName",
  Email = "Email",
  Id = "Id",
  Price = "Price",
  RequestStatus = "RequestStatus",
  StoreName = "StoreName",
}

export enum ExperienceRequestStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Pending = "Pending",
  Purchased = "Purchased",
  Refunded = "Refunded",
}

export enum ExperienceSalesOrderBy {
  CreatedAt = "CreatedAt",
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  Id = "Id",
  PaidAt = "PaidAt",
  RequestedProfit = "RequestedProfit",
  Status = "Status",
  Title = "Title",
}

export enum ExperienceStatus {
  Active = "Active",
  Inactive = "Inactive",
  Sold = "Sold",
}

/**
 * Youth is deprecated
 */
export enum Gender {
  Female = "Female",
  Male = "Male",
  Unisex = "Unisex",
  Youth = "Youth",
}

export enum GenderInputFilter {
  Female = "Female",
  Male = "Male",
  Youth = "Youth",
}

export enum HashtagsFilterOrderBy {
  name = "name",
}

export enum HostedTicketEventsOrderBy {
  CreatedAt = "CreatedAt",
  Name = "Name",
  StartsAt = "StartsAt",
  TicketPrice = "TicketPrice",
}

export enum InterviewAnswerVideoPostCandidateStatus {
  Accepted = "Accepted",
  ImageGenerationInProgress = "ImageGenerationInProgress",
  NotReviewed = "NotReviewed",
  Rejected = "Rejected",
}

/**
 * Automatic - Event-triggered (ex. expensive Memorabilia was created) or user initiated througth web
 * Manual - Created manually via backoffice or sent via campaign
 */
export enum InterviewCreationType {
  Automatic = "Automatic",
  Manual = "Manual",
}

/**
 * Apitemplate will be creating image asynchronously so this status is used to track the status of the image creation
 */
export enum InterviewImageStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

/**
 * Topic categories for interview questions
 */
export enum InterviewQuestionTopic {
  LocalSportScene = "LocalSportScene",
  Trending = "Trending",
  Viral = "Viral",
}

export enum InterviewSourceType {
  BigMoment = "BigMoment",
  InterviewNow = "InterviewNow",
  Memorabilia = "Memorabilia",
  Merch = "Merch",
  Other = "Other",
  PPVParticipant = "PPVParticipant",
  Paid = "Paid",
  Product = "Product",
  QAMillions = "QAMillions",
  TalentInvite = "TalentInvite",
  TicketEventParticipant = "TicketEventParticipant",
  UserRequest = "UserRequest",
}

/**
 * Invited - Invite is sent with or without interviewer assigned
 * InviteViewed - Interviewee visited Millions invite link, Interviewer auto-assign happens at this stage
 * ScheduleAttempted - Calendly link was opened
 * Scheduled - Interviewer/Admin setup a stream date
 * Completed - Stream has successfully ended AND all records are ready
 * Canceled - Either manually cancelled or automatically (nobody attended stream)
 */
export enum InterviewStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Draft = "Draft",
  InviteViewed = "InviteViewed",
  Invited = "Invited",
  RescheduleRequested = "RescheduleRequested",
  ScheduleAttempted = "ScheduleAttempted",
  Scheduled = "Scheduled",
}

export enum MatchupCorner {
  A = "A",
  B = "B",
}

export enum MediaJobStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
}

export enum MediaPostStatus {
  published = "published",
  scheduled = "scheduled",
  scheduledInstant = "scheduledInstant",
}

export enum MediaPostType {
  ImagePost = "ImagePost",
  VideoPost = "VideoPost",
}

export enum MediaPostsOrderBy {
  publishedAt = "publishedAt",
}

export enum MemorabiliaFulfillment {
  Athlete = "Athlete",
  Millions = "Millions",
}

export enum MemorabiliaOrderBy {
  createdAt = "createdAt",
  inappropriateImageCount = "inappropriateImageCount",
  price = "price",
  socialFollowerCount = "socialFollowerCount",
  title = "title",
}

export enum MemorabiliaProductType {
  Memorabilia = "Memorabilia",
  Product = "Product",
}

export enum MemorabiliaSaleMethod {
  auction = "auction",
  standard = "standard",
}

export enum MemorabiliaStatus {
  Active = "Active",
  Expired = "Expired",
  Removed = "Removed",
  Sold = "Sold",
}

export enum MentionType {
  ARTICLE = "ARTICLE",
  EDITED_VIDEO = "EDITED_VIDEO",
  MEDIA_POST = "MEDIA_POST",
  STREAM = "STREAM",
  VIDEO_REQUEST = "VIDEO_REQUEST",
}

export enum MerchCreationSource {
  Ai = "Ai",
  AutoGenerated = "AutoGenerated",
  Manual = "Manual",
}

export enum MerchLogoJobStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

/**
 * Used as a generic status for SubOrder
 */
export enum MerchOrderStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Pending = "Pending",
  Processing = "Processing",
}

export enum MerchProductOrderBy {
  Date = "Date",
  Price = "Price",
  StoreName = "StoreName",
  Title = "Title",
}

export enum MerchProductStatus {
  Active = "Active",
  Inactive = "Inactive",
  MockupsFailed = "MockupsFailed",
  PendingMockups = "PendingMockups",
}

export enum MerchProductType {
  Hat = "Hat",
  Joggers = "Joggers",
  ManHoodie = "ManHoodie",
  ManJoggers = "ManJoggers",
  ManRashGuard = "ManRashGuard",
  ManTShirt = "ManTShirt",
  ManTankTop = "ManTankTop",
  WomanHoodie = "WomanHoodie",
  WomanJoggers = "WomanJoggers",
  WomanRashGuard = "WomanRashGuard",
  WomanTShirt = "WomanTShirt",
  WomanTankTop = "WomanTankTop",
  YouthTShirt = "YouthTShirt",
}

export enum MerchType {
  Hat = "Hat",
  Hoodie = "Hoodie",
  Joggers = "Joggers",
  RashGuard = "RashGuard",
  TShirt = "TShirt",
}

export enum MyStreamAffiliateLinkActivity {
  Active = "Active",
  Inactive = "Inactive",
}

export enum MyStreamAffiliateLinksOrderBy {
  Commission = "Commission",
  Earned = "Earned",
  EventDate = "EventDate",
  EventName = "EventName",
}

export enum MyStreamAffiliateSalesOrderBy {
  Buyer = "Buyer",
  Commission = "Commission",
  PaidAt = "PaidAt",
  Status = "Status",
}

export enum MyTipsAndOrdersSalesOrderBy {
  CustomerEmail = "CustomerEmail",
  CustomerFirstName = "CustomerFirstName",
  Discount = "Discount",
  Earnings = "Earnings",
  PaidAt = "PaidAt",
  Type = "Type",
}

export enum OrderListOrderBy {
  Address = "Address",
  Discount = "Discount",
  Id = "Id",
  OrderDate = "OrderDate",
  TotalPrice = "TotalPrice",
}

export enum OrderSummaryType {
  campaign = "campaign",
  campaign_counter_offer = "campaign_counter_offer",
  campaign_counter_offer_hold = "campaign_counter_offer_hold",
  campaign_fee = "campaign_fee",
  cb_balance_topup = "cb_balance_topup",
  cb_plan = "cb_plan",
  direct_booking_fee = "direct_booking_fee",
  direct_booking_offer = "direct_booking_offer",
  stream_tip = "stream_tip",
  ticket = "ticket",
  user_tip = "user_tip",
}

/**
 * ProductOrder can be either Product or Memorabilia
 */
export enum OrderType {
  MerchOrder = "MerchOrder",
  ProductOrder = "ProductOrder",
}

export enum OrganizationType {
  AssociationLeagueTeam = "AssociationLeagueTeam",
  EventOrganizer = "EventOrganizer",
  Gym = "Gym",
  Other = "Other",
}

export enum PaymentStatus {
  canceled = "canceled",
  credited = "credited",
  failed = "failed",
  pending = "pending",
  refunded = "refunded",
  reserved = "reserved",
  successful = "successful",
}

export enum PaymentType {
  CbBalancePayment = "CbBalancePayment",
  CryptoPayment = "CryptoPayment",
  OfflinePayment = "OfflinePayment",
  StripeCardPayment = "StripeCardPayment",
}

export enum PlacementTypes {
  back = "back",
  embroidery_back = "embroidery_back",
  embroidery_front = "embroidery_front",
  embroidery_front_large = "embroidery_front_large",
  embroidery_left = "embroidery_left",
  embroidery_right = "embroidery_right",
  front = "front",
  leg_back_left = "leg_back_left",
  leg_back_right = "leg_back_right",
  leg_front_left = "leg_front_left",
  leg_front_right = "leg_front_right",
  pocket = "pocket",
  sleeve_left = "sleeve_left",
  sleeve_right = "sleeve_right",
}

export enum ProductSalesType {
  memorabilia = "memorabilia",
  merch = "merch",
  product = "product",
}

export enum ProductTypesType {
  Ama = "Ama",
  Experience = "Experience",
  Merch = "Merch",
  Product = "Product",
  Shoutout = "Shoutout",
  Stream = "Stream",
  Ticket = "Ticket",
}

export enum PromoCodesChargeSubject {
  Internal = "Internal",
  Platform = "Platform",
  Store = "Store",
}

export enum PublicStreamCategory {
  Interview = "Interview",
  Stream = "Stream",
}

export enum ScheduleRuleType {
  Date = "Date",
  WeekDay = "WeekDay",
}

export enum ScheduleType {
  Interview = "Interview",
}

export enum SignUpFlow {
  QuickFlow = "QuickFlow",
  RegularFlow = "RegularFlow",
}

export enum SignUpSource {
  BookMeProfile = "BookMeProfile",
  CbMentionLandingPage = "CbMentionLandingPage",
  CbTalentInviteLink = "CbTalentInviteLink",
  ExtTalentBrandDeal = "ExtTalentBrandDeal",
  PersonMention = "PersonMention",
}

/**
 * E-signature provider that owns the agreement
 */
export enum SignatureProviderName {
  DocuSeal = "DocuSeal",
}

/**
 * How the frontend shows the signing session
 */
export enum SigningSessionEmbedMode {
  Component = "Component",
  Iframe = "Iframe",
  Redirect = "Redirect",
}

export enum SocialMediaConnectionProvider {
  Facebook = "Facebook",
  Instagram = "Instagram",
  Tiktok = "Tiktok",
}

export enum SocialMediaType {
  Facebook = "Facebook",
  Instagram = "Instagram",
  Tiktok = "Tiktok",
  Twitter = "Twitter",
  Youtube = "Youtube",
}

/**
 * Social provider type
 */
export enum SocialProviderType {
  Apple = "Apple",
  Fb = "Fb",
  Google = "Google",
  Tiktok = "Tiktok",
  Twitter = "Twitter",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SponsoredAppearanceVideoType {
  Live = "Live",
  Recorded = "Recorded",
}

export enum StoreAthleticLevel {
  Amateur = "Amateur",
  CollegeUniversity = "CollegeUniversity",
  OlympicNational = "OlympicNational",
  Other = "Other",
  Professional = "Professional",
  RetiredProfessional = "RetiredProfessional",
}

export enum StoreCareerStatus {
  Active = "Active",
  Retired = "Retired",
}

export enum StoreGender {
  female = "female",
  male = "male",
  other = "other",
  preferNotToSay = "preferNotToSay",
}

export enum StoreStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum StoresOrderBy {
  activatedAt = "activatedAt",
  createdAt = "createdAt",
  firstName = "firstName",
  followerCount = "followerCount",
  lastName = "lastName",
  socialFollowerCount = "socialFollowerCount",
  storeName = "storeName",
  totalSales = "totalSales",
}

export enum StreamAffiliateLinkStatus {
  Active = "Active",
  Disabled = "Disabled",
}

export enum StreamAffiliateLinksOrderBy {
  Clicks = "Clicks",
  Commission = "Commission",
  Name = "Name",
  Revenue = "Revenue",
  Sales = "Sales",
  TicketsSold = "TicketsSold",
}

export enum StreamIntervalEnum {
  biweekly = "biweekly",
  monthly = "monthly",
  weekly = "weekly",
}

export enum StreamOrderBy {
  AiClipsCreatedAt = "AiClipsCreatedAt",
  Description = "Description",
  Name = "Name",
  Price = "Price",
  RequestedPrice = "RequestedPrice",
  ScheduleDate = "ScheduleDate",
  ScheduleDateStrict = "ScheduleDateStrict",
  StoreName = "StoreName",
  StreamStatus = "StreamStatus",
}

export enum StreamOrderSalesOrderBy {
  CreatedAt = "CreatedAt",
  CustomerFirstName = "CustomerFirstName",
  DiscountAmount = "DiscountAmount",
  PaidAt = "PaidAt",
  RequestedProfit = "RequestedProfit",
}

export enum StreamOrderSortBy {
  CreatedAt = "CreatedAt",
  Description = "Description",
  DiscountAmount = "DiscountAmount",
  OrderStatus = "OrderStatus",
  Price = "Price",
  ScheduleDate = "ScheduleDate",
  StoreName = "StoreName",
  StreamName = "StreamName",
  StreamStatus = "StreamStatus",
}

export enum StreamOrderStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Pending = "Pending",
  Processing = "Processing",
}

export enum StreamParticipantRowStatus {
  Active = "Active",
  Invited = "Invited",
}

export enum StreamParticipantsOrderBy {
  createdAt = "createdAt",
  firstName = "firstName",
  lastName = "lastName",
}

export enum StreamPriceCategory {
  Free = "Free",
  Paid = "Paid",
}

export enum StreamRecordAspectRatio {
  Landscape = "Landscape",
  Portrait = "Portrait",
}

export enum StreamSalesOrderBy {
  Earnings = "Earnings",
  Name = "Name",
  OrderCnt = "OrderCnt",
  ScheduleDate = "ScheduleDate",
  TipCnt = "TipCnt",
}

export enum StreamStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Ended = "Ended",
  Interrupted = "Interrupted",
  Paused = "Paused",
  Scheduled = "Scheduled",
}

export enum StreamSubtypeFilter {
  GuestInterview = "GuestInterview",
  HostInterview = "HostInterview",
  Participant = "Participant",
  Regular = "Regular",
  SponsoredAppearance = "SponsoredAppearance",
}

export enum StreamType {
  Interview = "Interview",
  SponsoredAppearanceDraft = "SponsoredAppearanceDraft",
  SponsoredAppearanceLive = "SponsoredAppearanceLive",
  SponsoredAppearanceRec = "SponsoredAppearanceRec",
  Stream = "Stream",
}

export enum StripeIntentStatus {
  canceled = "canceled",
  processing = "processing",
  requires_action = "requires_action",
  requires_capture = "requires_capture",
  requires_confirmation = "requires_confirmation",
  requires_payment_method = "requires_payment_method",
  succeeded = "succeeded",
}

export enum TalentInviteLinkType {
  ALL_DEALS = "ALL_DEALS",
  SPECIFIC_CAMPAIGN = "SPECIFIC_CAMPAIGN",
}

export enum TargetType {
  REGISTERED = "REGISTERED",
  UNREGISTERED = "UNREGISTERED",
}

export enum TaskExtensionRequestStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum TaskExtensionRequestType {
  CONTENT = "CONTENT",
  EVENT = "EVENT",
  PUBLISH = "PUBLISH",
}

export enum TicketEventOrderSort {
  AdmissionCount = "AdmissionCount",
  Amount = "Amount",
  CreatedAt = "CreatedAt",
  CustomerName = "CustomerName",
  Reference = "Reference",
  Status = "Status",
}

export enum TicketEventStatus {
  Cancelled = "Cancelled",
  Closed = "Closed",
  Draft = "Draft",
  OnSale = "OnSale",
  Paused = "Paused",
  Postponed = "Postponed",
}

export enum TicketEventTiming {
  Live = "Live",
  Past = "Past",
  Upcoming = "Upcoming",
}

export enum TicketEventsOrderBy {
  Name = "Name",
  StartsAt = "StartsAt",
  TicketPrice = "TicketPrice",
}

export enum TicketOrderKind {
  Comp = "Comp",
  Purchase = "Purchase",
}

export enum TicketOrderStatus {
  Cancelled = "Cancelled",
  Confirmed = "Confirmed",
  Expired = "Expired",
  PaymentReview = "PaymentReview",
  PendingPayment = "PendingPayment",
  RefundPending = "RefundPending",
  Refunded = "Refunded",
  Reserved = "Reserved",
}

export enum TicketStatus {
  Active = "Active",
  Admitted = "Admitted",
  Revoked = "Revoked",
}

export enum TicketTierSaleState {
  NotYetOnSale = "NotYetOnSale",
  OnSale = "OnSale",
  SalesEnded = "SalesEnded",
  SalesPaused = "SalesPaused",
  SoldOut = "SoldOut",
}

export enum TicketTransferStatus {
  Accepted = "Accepted",
  Cancelled = "Cancelled",
  Expired = "Expired",
  Pending = "Pending",
  Voided = "Voided",
}

export enum TipImageStatus {
  completed = "completed",
  failed = "failed",
  inProgress = "inProgress",
}

export enum TipOrderBy {
  amount = "amount",
  createdAt = "createdAt",
}

export enum TipStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Pending = "Pending",
}

export enum TipType {
  Stream = "Stream",
  User = "User",
}

export enum TrackedShareTarget {
  Copy = "Copy",
  FB = "FB",
  IGMessage = "IGMessage",
  IGStory = "IGStory",
  Other = "Other",
  WhatsApp = "WhatsApp",
}

export enum TrackedSourceType {
  AiMerchFunnel = "AiMerchFunnel",
  MediaPost = "MediaPost",
}

export enum UnregisteredContactOrderBy {
  createdAt = "createdAt",
  name = "name",
  timesMentioned = "timesMentioned",
}

export enum UserBlackListOrderBy {
  BlockType = "BlockType",
  CreatedAt = "CreatedAt",
}

/**
 * Gym is deprecated and substituted with Organization
 */
export enum UserRole {
  Admin = "Admin",
  Agency = "Agency",
  Association = "Association",
  Athlete = "Athlete",
  Charity = "Charity",
  Coach = "Coach",
  ContentCreator = "ContentCreator",
  Customer = "Customer",
  Designer = "Designer",
  Guest = "Guest",
  Gym = "Gym",
  ManagementFirm = "ManagementFirm",
  Moderator = "Moderator",
  Organization = "Organization",
  Team = "Team",
  Trainer = "Trainer",
  VideoEditor = "VideoEditor",
}

/**
 * Todo - created from trigger if no editors available
 */
export enum VideoEditRequestStatus {
  Accepted = "Accepted",
  Archived = "Archived",
  AutoAccepted = "AutoAccepted",
  InProgress = "InProgress",
  OnReview = "OnReview",
  PartialyRejected = "PartialyRejected",
  Rejected = "Rejected",
  Todo = "Todo",
}

export enum VideoEditRequestSubmissionStatus {
  Approved = "Approved",
  AutoApproved = "AutoApproved",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum VideoEditRequestsStoreOrderBy {
  assignedEditor = "assignedEditor",
  createdAt = "createdAt",
  dueDate = "dueDate",
  status = "status",
  storeName = "storeName",
  videoEditRequestType = "videoEditRequestType",
  videoEditorName = "videoEditorName",
}

export enum WeekDay {
  friday = "friday",
  monday = "monday",
  saturday = "saturday",
  sunday = "sunday",
  thursday = "thursday",
  tuesday = "tuesday",
  wednesday = "wednesday",
}

export interface AcceptAiClipCandidateInput {
  body?: string | null;
  candidateId: string;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  ownerId?: string | null;
  title?: string | null;
}

export interface AcceptCampaignOfferByStoreInput {
  addressId?: string | null;
  offerId: string;
  ownerId?: string | null;
}

export interface AcceptDirectBookingOfferInput {
  addressId?: string | null;
  offerId: string;
  ownerId?: string | null;
}

export interface AcceptInterviewAnswerInput {
  body?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  title?: string | null;
  videoId: string;
}

export interface AcceptInterviewInviteInput {
  autoAssign?: boolean | null;
  interviewId: string;
}

export interface AcceptMatchupInviteInput {
  inviteToken: string;
}

export interface AcceptMerchDesignInput {
  designRequestId: string;
  feedback?: string | null;
  rate?: number | null;
}

export interface AcceptOptInMerchInput {
  blueprintId: string;
}

export interface AcceptSignedMemorabiliaInput {
  blueprintId: string;
}

export interface AcceptTicketTransferInput {
  secret: string;
  transferId: string;
}

export interface AcceptVideoEditSubmissionInput {
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
}

export interface AcceptVideoEditSubmissionsInput {
  feedback?: string | null;
  rate: number;
  requestId: string;
  submissions: AcceptVideoEditSubmissionInput[];
}

export interface AddParticipantsToStreamInput {
  invite: string;
  streamId: string;
}

export interface AddStreamAffiliateInput {
  commissionPercent?: number | null;
  streamId?: string | null;
  userId: string;
  ticketEventId?: string | null;
}

export interface AddTicketTierInput {
  capacity: number;
  description?: string | null;
  label: string;
  maxPerOrder?: number | null;
  price: number;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
  ticketEventId: string;
}

export interface AllHashtagsFilterInput {
  direction?: SortDirection | null;
  generalOnly?: boolean | null;
  hashtagNames?: string[] | null;
  keyword?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: HashtagsFilterOrderBy | null;
  sportIds?: number[] | null;
}

export interface AmaFilterInput {
  daysToResponse?: FromToFilter | null;
  direction?: SortDirection | null;
  hashtagIds?: number[] | null;
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaOrderBy | null;
  price?: FromToFilter | null;
  sports?: number[] | null;
  status?: AmaStatus | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeStatus?: StoreStatus | null;
}

export interface AmaItemCreateInput {
  daysToResponse: number;
  requestedPrice: number;
  status: AmaStatus;
  type: AmaType;
}

export interface AmaItemEditInput {
  daysToResponse: number;
  id?: string | null;
  requestedPrice: number;
  status: AmaStatus;
  type: AmaType;
}

export interface AmaRequestCreateInput {
  amaId: string;
  email?: string | null;
  from?: string | null;
  instructions?: string | null;
  promocodeId?: string | null;
  to?: string | null;
}

export interface AmaRequestCreatePresignedUrlInput {
  id: string;
}

export interface AmaRequestDeclineInput {
  declineReason: string;
  id: string;
}

export interface AmaRequestListFilter {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AmaRequestOrderBy | null;
}

export interface AmaRequestSubmitVideoInput {
  id: string;
  videoKey: string;
}

export interface AmaVideoInput {
  area: VideoCroppedArea;
  type?: string | null;
  videoKey: string;
}

export interface AmasCreateInput {
  amas: AmaItemCreateInput[];
  video?: VideoCroppedInput | null;
  videoV2?: AmaVideoInput | null;
}

export interface AmasEditInput {
  amas?: AmaItemEditInput[] | null;
  deleteVideo?: boolean | null;
  video?: VideoCroppedInput | null;
  videoV2?: AmaVideoInput | null;
}

export interface AppearanceStreamInput {
  description: string;
  hashtagInputs?: HashtagInput[] | null;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
}

export interface AppearanceStreamRecordInput {
  key: string;
}

export interface AppleAuthInput {
  identityToken: string;
}

export interface ApplyForCampaignOfferInput {
  addressId?: string | null;
  answers?: CbApplicationAnswersInput[] | null;
  offerId: string;
  ownerId?: string | null;
}

export interface ApplyForChannelMonetizationInput {
  ownerId?: string | null;
}

export interface ApplyTicketHoldPromocodeInput {
  holdId: string;
  promocode?: string | null;
}

export interface ApproveAutoGeneratedMerchInput {
  types: AutoGeneratedLogoType[];
}

export interface ApproveTicketZeroTaxInput {
  expectedVersion: number;
  ticketEventId: string;
}

export interface ArticleBySlugInput {
  articleSlug: string;
  storeSlug: string;
}

export interface ArticleStoreFilterInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ArticleStoreOrderBy | null;
  searchTerm?: string | null;
  statuses?: ArticleStatus[] | null;
  storeId?: string | null;
  storeSlug?: string | null;
}

export interface ArticlesByHashtagInput {
  direction?: SortDirection | null;
  hashtagName: string;
  limit?: number | null;
  startAfter?: string | null;
}

export interface AttachThankYouVideoInput {
  orderId: string;
  productType: ProductTypesType;
  storeId?: string | null;
  video: any;
}

export interface AttachThankYouVideoStreamInput {
  storeId?: string | null;
  streamId: string;
  video: any;
}

export interface AttachThankYouVideoTemplateInput {
  orderId: string;
  productType: ProductTypesType;
  storeId?: string | null;
  thankYouVideoId: string;
}

export interface AttachThankYouVideoTemplateStreamInput {
  storeId?: string | null;
  streamId: string;
  thankYouVideoId: string;
}

export interface AuctionFromToInput {
  onAuctionFrom: any;
  onAuctionTo: any;
}

export interface AvailableSlotsDateRangeInput {
  from: any;
  to: any;
}

export interface BookInterviewSlotInput {
  guestNotes?: string | null;
  guestTimezone?: string | null;
  interviewId: string;
  interviewerId?: string | null;
  startDateUtc: any;
}

export interface CalculateGrossFromNetInput {
  netAmount: number;
  offerId: string;
}

export interface CampaignOfferSubmissionInput {
  imageKey?: string | null;
  link?: string | null;
  platformMediaId?: string | null;
  taskId?: string | null;
  type: CampaignTaskType;
}

export interface CanScheduleInterviewInput {
  ownerId?: string | null;
}

export interface CanUseSocialMediaIntegrationInput {
  ownerId?: string | null;
}

export interface CancelInterviewByHostInput {
  id: string;
  option: CancellationOption;
}

export interface CancelInterviewInput {
  id: string;
}

export interface CancelTicketTransferInput {
  transferId: string;
}

export interface CbApplicationAnswersInput {
  answer: string;
  questionId: string;
}

export interface ChangePasswordInput {
  newPassword: string;
  oldPassword?: string | null;
}

export interface CheckEmailAvailabilityInput {
  email: string;
  ownerId?: string | null;
}

export interface CheckUsernameAvailabilityInput {
  ownerId?: string | null;
  username: string;
}

export interface CheckoutTicketOrderInput {
  billingAddressId?: string | null;
  contactEmail?: string | null;
  currency: string;
  expectedTotal: number;
  holdId: string;
  paymentMethodId: string;
  affiliateCode?: string | null;
}

export interface CityFilterInput {
  countryCode: string;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
}

export interface ClaimSocialBoostOfferInput {
  offerId: string;
}

export interface CompleteFacebookAuthInput {
  pageId: string;
  sessionId: string;
}

export interface CompleteInstagramAuthInput {
  code: string;
  redirectUrl: string;
}

export interface CompleteMultipartUploadInput {
  fileId: string;
  fileKey: string;
  parts: CompleteMultipartUploadPartInput[];
}

export interface CompleteMultipartUploadPartInput {
  ETag: string;
  PartNumber: number;
}

export interface CompleteStripePaymentInput {
  stripeIntentID: string;
}

export interface CompleteTiktokIntegrationAuthInput {
  code: string;
  redirectUrl: string;
}

export interface CountryFilterInput {
  code?: string | null;
  name?: string | null;
}

export interface CreateAddressInput {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  company?: string | null;
  country?: string | null;
  countryCode: string;
  email?: string | null;
  firstName?: string | null;
  isDefault?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  phoneNumberE164?: string | null;
  state?: string | null;
  stateCode?: string | null;
  userId?: string | null;
  zipCode: string;
}

export interface CreateAppearanceStreamInput {
  ownerId?: string | null;
  stream: AppearanceStreamInput;
  submissionId: string;
}

export interface CreateCampaignExampleFileInput {
  name: string;
}

export interface CreateCampaignExampleFilesInput {
  files: CreateCampaignExampleFileInput[];
}

export interface CreateCampaignSubmissionFileInput {
  name: string;
}

export interface CreateCampaignSubmissionFilesInput {
  files: CreateCampaignSubmissionFileInput[];
  offerId: string;
}

export interface CreateDeliverableFileInput {
  name: string;
}

export interface CreateDeliverableFilesInput {
  files: CreateDeliverableFileInput[];
}

export interface CreateDesignImageExamplePresignedUrlInput {
  numberOfImages: number;
}

export interface CreateExperienceImagePresignedUrlInput {
  numberOfImages: number;
}

export interface CreateImagePostInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  image: CreatePostImageInput;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  title: string;
}

export interface CreateMatchupCompetitorInput {
  corner: MatchupCorner;
  inviteToken?: string | null;
  invitedEmail?: string | null;
  invitedPhone?: string | null;
  name?: string | null;
  storeId?: string | null;
}

export interface CreateMatchupInput {
  category?: string | null;
  competitors: CreateMatchupCompetitorInput[];
  id?: string | null;
  isMainEvent?: boolean | null;
  order?: number | null;
  roundMinutes?: number | null;
  rounds?: number | null;
}

export interface CreateMemorabiliaImagePresignedUrl {
  numberOfImages: number;
}

export interface CreateMemorabiliaInput {
  addressId?: string | null;
  auctionDateRange?: AuctionFromToInput | null;
  comment?: string | null;
  customsDescription?: string | null;
  description?: string | null;
  fulfillment: MemorabiliaFulfillment;
  hashtagInputs?: HashtagInput[] | null;
  height?: number | null;
  images: MemorabiliaImageInput[];
  length?: number | null;
  memorabiliaProductType: MemorabiliaProductType;
  numberOfUnits: number;
  requestedPrice: number;
  shipmentCategory: string;
  storeId: string;
  title: string;
  weight?: number | null;
  width?: number | null;
}

export interface CreateMentionInput {
  storeId?: string | null;
  unregisteredContactId?: string | null;
}

export interface CreateMerchDesignInput {
  designColorPaletteIds: number[];
  designCustomColor?: string | null;
  designExtraInfo?: string | null;
  designName: string;
  designSampleIds: number[];
  designStyleSettingsInput: DesignStyleSettingsInput;
  designTypeIds: number[];
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
}

export interface CreateMerchDesignLogoInput {
  key: string;
}

export interface CreateMerchDesignWithLogoInput {
  designExtraInfo?: string | null;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
  storeLogos: CreateMerchDesignLogoInput[];
}

export interface CreateMerchOrderItem {
  amount: number;
  memorabiliaId?: string | null;
  oldVariantId?: number | null;
  variantId?: number | null;
}

export interface CreateMerchOrderItemInput {
  items: CreateMerchOrderItem[];
}

export interface CreateMerchProductInput {
  customImages?: MerchCustomImageInput[] | null;
  designRequestId?: string | null;
  finalMerchStatus?: MerchProductStatus | null;
  hashtagInputs?: HashtagInput[] | null;
  merchProductType: MerchProductType;
  printfulVariantIds: number[];
  productPrintFiles: ProductPrintFileInput[];
  requestedProfit: number;
  stitches?: string | null;
  storeId?: string | null;
  threads?: string | null;
  title: string;
}

export interface CreateMerchProductV2Input {
  creationSource?: MerchCreationSource | null;
  customImageSets?: MerchProductCustomImageSetInput[] | null;
  hashtagInputs?: HashtagInput[] | null;
  printFileSets: MerchProductPrintFileSetInput[];
  requestedProfit: number;
  title: string;
  type: MerchType;
  variantSets: MerchProductVariantSet[];
}

export interface CreateOrderInput {
  addressId: string;
  billingAddressId: string;
  paymentMethodId?: string | null;
  promocodeId?: string | null;
}

export interface CreatePastAppearanceStreamInput {
  ownerId?: string | null;
  stream: PastAppearanceStreamInput;
  submissionId: string;
}

export interface CreatePostImageInput {
  key: string;
}

export interface CreatePostImagePresignedUrlV2FileInput {
  contentType: string;
  ext: string;
}

export interface CreatePostImagePresignedUrlV2Input {
  files: CreatePostImagePresignedUrlV2FileInput[];
  mediaPostId?: string | null;
}

export interface CreatePostVideoInput {
  key: string;
}

export interface CreateStoreExampleImageInput {
  key: string;
}

export interface CreateStoreExperienceInput {
  comment?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  images: ExperienceImageInput[];
  numberOfUnits?: number | null;
  requestedPrice: number;
  title: string;
}

export interface CreateStreamImageInput {
  files: StreamImageItemInput[];
}

export interface CreateStreamOverlayLogoInput {
  files: CreateStreamOverlayLogoItemInput[];
  streamId: string;
}

export interface CreateStreamOverlayLogoItemInput {
  contentType: string;
  ext: string;
}

export interface CreateThankYouVideoTemplateInput {
  productType: ProductTypesType;
  storeId?: string | null;
  video: any;
}

export interface CreateTicketEventInput {
  admissionClosesAt?: any | null;
  coverImageFileKey?: string | null;
  description?: string | null;
  doorsOpenAt?: any | null;
  endsAt?: any | null;
  entryRequirements?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  leagueId?: string | null;
  matchups?: CreateMatchupInput[] | null;
  maxAdmissions?: number | null;
  minimumAge?: number | null;
  name?: string | null;
  ownerId?: string | null;
  promotion?: string | null;
  refundPolicy?: string | null;
  repeatsEvery?: StreamIntervalEnum | null;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
  sportIds?: number[] | null;
  startsAt?: any | null;
  streamId?: string | null;
  termsAndConditions?: string | null;
  ticketsEnabled?: boolean | null;
  tiers?: TicketTierDetailsInput[] | null;
  venue?: TicketVenueDetailsInput | null;
  venueId?: string | null;
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  fanPollingEnabled?: boolean | null;
}

export interface CreateTicketHoldInput {
  items: TicketHoldItemInput[];
  presaleCode?: string | null;
  ticketEventId: string;
}

export interface CreateUnregisteredContactInput {
  email?: string | null;
  name?: string | null;
  phoneNumberE164?: string | null;
  representativeName?: string | null;
  socialMediaLink?: string | null;
  type: ContactType;
  url?: string | null;
}

export interface CreateUserAvatarUrlInput {
  contentType: string;
  ext: string;
}

export interface CreateUserInitiatedInterviewInput {
  guestNotes?: string | null;
  guestTimezone?: string | null;
  interviewerId: string;
  questions?: QuestionInputData[] | null;
  startDateUtc: any;
}

export interface CreateUserToUserInitiatedInterviewInput {
  guestNotes?: string | null;
  guestTimezone?: string | null;
  interviewerId: string;
  questions?: QuestionInputData[] | null;
  startDateUtc: any;
}

export interface CreateVariantPrintfilePresignedUrlsInput {
  files: VariantPrintfilePresignedUrlInput[];
}

export interface CreateVerificationVideoInput {
  file: any;
  type?: string | null;
}

export interface CreateVideoPostInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  thumbnailKey?: string | null;
  title: string;
  video: CreatePostVideoInput;
}

export interface DateV2Input {
  tz?: string | null;
  utc: any;
}

export interface DeclareMatchupWinnerInput {
  matchupId: string;
  winnerCorner?: MatchupCorner | null;
}

export interface DeclineSocialBoostOfferInput {
  offerId: string;
}

export interface DeleteMediaPostInput {
  id: string;
}

export interface DeleteMemorabiliaInput {
  id: string;
  storeId?: string | null;
}

export interface DeleteStoreExperienceInput {
  id: string;
}

export interface DeleteThankYouVideoTemplateInput {
  storeId?: string | null;
  thankYouVideoId: string;
}

export interface DeliverableFileInput {
  key: string;
  name: string;
}

export interface DeliverableItemInput {
  copy?: string | null;
  key?: string | null;
  name?: string | null;
  taskId: string;
  type: CBDeliverableItemType;
  videoTranscodingJobId?: string | null;
}

export interface DesignRequestsFilterInput {
  designRequestId?: string | null;
  designRequestIds?: string[] | null;
  designRequestStatuses?: DesignRequestStatus[] | null;
  designRequestType?: DesignRequestType | null;
  designRequestTypes?: DesignRequestType[] | null;
  designerIds?: string[] | null;
  designerName?: string | null;
  direction?: SortDirection | null;
  escalatedToId?: string | null;
  isAwaitingAthleteApproval?: boolean | null;
  isInProgress?: boolean | null;
  isOverdue?: boolean | null;
  isUnassigned?: boolean | null;
  limit?: number | null;
  managedById?: string | null;
  offset?: number | null;
  orderBy?: DesignRequestsOrderBy | null;
  storeIds?: string[] | null;
  storeName?: string | null;
}

export interface DesignStyleSettingsInput {
  abstractLiteral?: number | null;
  classicModern?: number | null;
  economicalLuxurious?: number | null;
  feminineMasculine?: number | null;
  geometricOrganic?: number | null;
  matureYouthful?: number | null;
  playfulSophisticated?: number | null;
}

export interface DigitalAgreementIdInput {
  agreementId: string;
}

export interface DimensionsInput {
  height: number;
  width: number;
}

export interface EarthCoordinateInput {
  latitude: number;
  longitude: number;
}

export interface EditAppearanceStreamInput {
  ownerId?: string | null;
  stream: AppearanceStreamInput;
  streamId: string;
}

export interface EditImagePostInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  image: EditPostImageInput;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  title: string;
}

export interface EditMerchDesignInput {
  designColorPaletteIds?: number[] | null;
  designCustomColor?: string | null;
  designExtraInfo?: string | null;
  designName?: string | null;
  designRequestId: string;
  designSampleIds?: number[] | null;
  designStyleSettingsInput?: DesignStyleSettingsInput | null;
  designTypeIds?: number[] | null;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
}

export interface EditMerchDesignWithLogoInput {
  designExtraInfo?: string | null;
  designRequestId: string;
  merchProductTypes?: MerchProductType[] | null;
  merchTypes?: MerchType[] | null;
  socialMediaURL?: string | null;
  storeExampleImages?: CreateStoreExampleImageInput[] | null;
  storeLogos?: CreateMerchDesignLogoInput[] | null;
}

export interface EditMerchProductV2Input {
  customImageSets?: MerchProductCustomImageSetInput[] | null;
  hashtagInputs?: HashtagInput[] | null;
  id: number;
  printFileSets?: MerchProductPrintFileSetInput[] | null;
  requestedProfit: number;
  title: string;
  type: MerchType;
  variantSets?: MerchProductVariantSet[] | null;
}

export interface EditPostImageInput {
  id?: string | null;
  key?: string | null;
}

/**
 * Provide either id to keep existing video or a key to upload new video
 */
export interface EditPostVideoInput {
  id?: string | null;
  key?: string | null;
}

export interface EditVideoPostInput {
  body?: string | null;
  buyProductLink?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  mentionsInputs?: CreateMentionInput[] | null;
  scheduled?: ScheduleDateInput | null;
  scheduledV2?: ScheduledPostDateV2Input | null;
  thumbnailKey?: string | null;
  title: string;
  video: EditPostVideoInput;
}

export interface EstimateAuctionDeliveryInput {
  addressId?: string | null;
  auctionId: string;
  bidAmount: number;
}

export interface EstimateMerchPriceByTypeInput {
  ownerId?: string | null;
  type: MerchType;
}

export interface EstimateMerchPriceInput {
  ownerId?: string | null;
  printFileSets: MerchEstimatePrintFileSetInput[];
  requestedProfit: number;
  type: MerchType;
  variantSets: MerchProductVariantSet[];
}

export interface EstimateOrderInput {
  addressId: string;
  billingAddressId: string;
  promocodeId?: string | null;
}

export interface EstimateStreamOrderInput {
  billingAddressId: string;
  promocodeId?: string | null;
  streamId: string;
}

export interface EstimateStreamPriceInput {
  finalPrice: number;
  ownerId?: string | null;
}

export interface ExperienceFilterInput {
  description?: string | null;
  direction?: SortDirection | null;
  id?: string | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ExperienceOrderBy | null;
  price?: FromToFilter | null;
  searchTerm?: string | null;
  sports?: number[] | null;
  statuses?: ExperienceStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  title?: string | null;
}

export interface ExperienceImageInput {
  experienceImageFileKey: string;
  isMainImage?: boolean | null;
}

export interface ExperiencePriceEstimateInput {
  ownerId?: string | null;
  requestedPrice: number;
}

export interface ExperienceRequestCreateInput {
  email?: string | null;
  experienceId: string;
  phoneNumber?: string | null;
  phoneNumberE164?: string | null;
  quantity: number;
}

export interface ExperienceRequestListFilter {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ExperienceRequestOrderBy | null;
}

export interface ExperienceSalesInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerEmail?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  experienceId?: string | null;
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: ExperienceSalesOrderBy | null;
  statuses?: ExperienceRequestStatus[] | null;
  storeId?: string | null;
  storeName?: string | null;
  title?: string | null;
}

export interface FbAuthInput {
  accessToken: string;
}

export interface FindOrderInput {
  email: string;
  orderId: number;
}

export interface FollowStoresInput {
  storeIds: string[];
}

export interface FromToDatesFilter {
  from?: any | null;
  to?: any | null;
}

export interface FromToFilter {
  from?: number | null;
  to?: number | null;
}

export interface GenerateAiMerchLogoInput {
  colors?: string[] | null;
  merchType?: MerchType | null;
  ownerId?: string | null;
  referenceImageKey?: string | null;
  styles: AiMerchLogoStyle[];
  text: string;
}

export interface GetAddressesInput {
  userId: string;
}

export interface GetAffiliateStreamProductsInput {
  streamId: string;
}

export interface GetAllAvailableSchedulesSlotsInput {
  dateRange: AvailableSlotsDateRangeInput;
  type?: ScheduleType | null;
  userIds: string[];
}

export interface GetAnyProductSalesInput {
  createdAtDateRange?: FromToDatesFilter | null;
  customerEmail?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: AnyProductSalesOrderBy | null;
  orderId?: string | null;
  orderIdStrict?: number | null;
  storeId?: string | null;
  subOrderStatuses?: MerchOrderStatus[] | null;
  subtotalRange?: FromToFilter | null;
  totalStoreRevenuesRange?: FromToFilter | null;
  types?: ProductSalesType[] | null;
}

export interface GetAvailableInterviewerInput {
  source?: InterviewSourceType | null;
}

export interface GetAvailableInterviewersInput {
  source?: InterviewSourceType | null;
}

export interface GetAvailableScheduleSlotsInput {
  dateRange: AvailableSlotsDateRangeInput;
  type?: ScheduleType | null;
  userId: string;
}

export interface GetCbTaskExtensionHistoryInput {
  deliverableId?: string | null;
  offerId: string;
  requestId?: string | null;
}

export interface GetChannelMonetizationDataInput {
  ownerId?: string | null;
}

export interface GetChannelMonetizationLeaderboardInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
}

export interface GetConnectedSocialMediaPostsInput {
  cursor?: string | null;
  limit?: number | null;
  provider: SocialMediaConnectionProvider;
  taskType: CampaignTaskType;
}

export interface GetCounterOfferHistoryInput {
  offerId: string;
}

export interface GetFacebookPagesInput {
  accessToken?: string | null;
  code?: string | null;
  redirectUrl: string;
}

export interface GetFollowersInput {
  direction?: SortDirection | null;
  followerRoles?: UserRole[] | null;
  limit?: number | null;
  offset?: number | null;
  ownerId?: string | null;
  searchTerm?: string | null;
  storeId?: string | null;
}

export interface GetInterviewAvailableSlotsInput {
  dateRange: AvailableSlotsDateRangeInput;
  interviewId: string;
}

export interface GetInterviewImageStateInput {
  id: string;
}

export interface GetInterviewScheduleInput {
  interviewId: string;
}

export interface GetInterviewTaskInput {
  id: string;
}

export interface GetMediaPostInput {
  id?: string | null;
  slug?: string | null;
  storeSlug?: string | null;
}

export interface GetMediaPostsInput {
  direction?: SortDirection | null;
  ids?: string[] | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MediaPostsOrderBy | null;
  searchTerm?: string | null;
  statuses?: MediaPostStatus[] | null;
  storeId?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  type?: MediaPostType[] | null;
}

export interface GetMerchProductInput {
  id?: number | null;
  slug?: string | null;
  storeSlug?: string | null;
}

export interface GetMerchProductsByIds {
  ids?: number[] | null;
}

export interface GetMerchProductsInput {
  color?: MerchProductColor[] | null;
  createdByRoles?: UserRole[] | null;
  direction?: SortDirection | null;
  gender?: Gender[] | null;
  genderV2?: GenderInputFilter[] | null;
  ids?: number[] | null;
  isCreatedByAdmin?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MerchProductOrderBy | null;
  price?: FromToFilter | null;
  searchTerm?: string | null;
  size?: string[] | null;
  sports?: number[] | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  title?: string | null;
  type?: MerchType[] | null;
}

export interface GetMyCampaignOfferByCampaignInput {
  campaignId: string;
  ownerId?: string | null;
}

export interface GetMyCampaignOfferInput {
  offerId: string;
  ownerId?: string | null;
}

export interface GetMyCampaignOfferSignedAgreementUrlInput {
  offerId: string;
}

export interface GetMyCampaignOffersInput {
  ageRange?: FromToFilter | null;
  appliedAtRange?: FromToDatesFilter | null;
  approvedAtRange?: FromToDatesFilter | null;
  campaignName?: string | null;
  campaignTypes?: CampaignType[] | null;
  countries?: string[] | null;
  createdAtRange?: FromToDatesFilter | null;
  declinedAtRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  engagementRateRange?: FromToFilter | null;
  genders?: CampaignOfferGenderFilter[] | null;
  includeInviteLinkOffers?: boolean | null;
  includeShelvedOffers?: boolean | null;
  internalName?: string | null;
  isInviteLinkOffer?: boolean | null;
  isProductSent?: boolean | null;
  isShelved?: boolean | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: CampaignOffersOrderBy | null;
  socialFollowingLiveRange?: FromToFilter | null;
  socialFollowingRange?: FromToFilter | null;
  socialMediaType?: SocialMediaType | null;
  sports?: string[] | null;
  states?: string[] | null;
  statuses?: CampaignOfferStatus[] | null;
  statusesV2?: CampaignOfferStatus[] | null;
  submittedAtRange?: FromToDatesFilter | null;
  totalFeeRange?: FromToFilter | null;
}

export interface GetMyMerchProductsInput {
  includeAllStatuses?: boolean | null;
}

export interface GetMyRecentActivityInput {
  dateRange?: FromToDatesFilter | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
}

export interface GetMyScheduleInput {
  type?: ScheduleType | null;
}

export interface GetNotReviewedAiClipCandidatesInput {
  ownerId?: string | null;
}

export interface GetNotReviewedVideosInput {
  ownerId?: string | null;
}

export interface GetNumberOfFollowersInput {
  storeId: string;
}

export interface GetOrdersInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: OrderListOrderBy | null;
  userId?: string | null;
}

export interface GetPaymentByExternalIdInput {
  externalOrderId: string;
  orderType?: OrderSummaryType | null;
}

export interface GetPersonMentionLandingProfileInput {
  contactId?: string | null;
  extTalentId: string;
  mentionId?: string | null;
}

export interface GetPlaceDetailsInput {
  id: string;
  sessionToken?: string | null;
}

export interface GetPlacePredictionsInput {
  includedPrimaryTypes?: string[] | null;
  query: string;
  sessionToken?: string | null;
}

export interface GetPlatformUsageStatsInput {
  ownerId?: string | null;
}

export interface GetPrProductsInput {
  type: MerchType;
}

export interface GetPromoCodeInput {
  amaId?: string | null;
  customerId?: string | null;
  id?: string | null;
  merchIds?: number[] | null;
  name?: string | null;
  streamId?: string | null;
}

export interface GetScheduleInput {
  type?: ScheduleType | null;
  userId: string;
}

export interface GetSportsInput {
  name?: string | null;
  storeRoles?: UserRole[] | null;
}

export interface GetStoreMemorabiliaInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MemorabiliaOrderBy | null;
  storeId?: string | null;
  storeSlug?: string | null;
}

export interface GetStoreMerchProductsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MerchProductOrderBy | null;
  storeId?: string | null;
  storeSlug?: string | null;
}

export interface GetStoreStreamsInput {
  accountTypes?: AccountType[] | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamOrderBy | null;
  scheduleDate?: FromToDatesFilter | null;
  storeId?: string | null;
  storeSlug?: string | null;
  streamStatus?: StreamStatus[] | null;
}

export interface GetStreamByInviteInput {
  inviteToken: string;
}

export interface GetStreamInput {
  id?: string | null;
  slug?: string | null;
  storeId?: string | null;
  storeSlug?: string | null;
}

export interface GetStreamUsersInput {
  id?: string | null;
  limit?: number | null;
  offset?: number | null;
  slug?: string | null;
}

export interface GetThankYouVideByOrderIdInput {
  orderId: string;
  productType?: ProductTypesType | null;
}

export interface GetThankYouVideoTemplateInput {
  productType: ProductTypesType;
  storeId?: string | null;
}

export interface GetTipImageStateInput {
  id: string;
}

export interface GetTipType {
  id: string;
  ownerId?: string | null;
}

export interface GetUnregisteredContactsInput {
  direction?: SortDirection | null;
  email?: string | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: UnregisteredContactOrderBy | null;
  representativeName?: string | null;
  type?: ContactType | null;
}

export interface GetUserBlackListInput {
  direction?: SortDirection | null;
  orderBy?: UserBlackListOrderBy | null;
  streamId?: string | null;
  userId: string;
}

export interface GetVideoTranscodingJobsInput {
  ids: string[];
}

export interface GoogleAuthInput {
  code: string;
  redirectUrl?: string | null;
}

export interface HandleCounterOfferInput {
  action?: CounterOfferAction | null;
  addressId?: string | null;
  amount?: number | null;
  answers?: CbApplicationAnswersInput[] | null;
  counterProposalId?: string | null;
  message?: string | null;
  offerId?: string | null;
  payWith?: CbPaymentSource | null;
  paymentMethodId?: string | null;
}

export interface HashtagInput {
  name: string;
}

export interface HideStreamInput {
  id: string;
}

export interface HostedTicketEventInput {
  ticketEventId: string;
}

export interface HostedTicketEventsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: HostedTicketEventsOrderBy | null;
  ownerId?: string | null;
  statuses?: TicketEventStatus[] | null;
  searchTerm?: string | null;
}

export interface InitAuthTwitterInput {
  redirectUrl: string;
}

export interface InitDeliverableFileMultipartUploadInput {
  campaignId: string;
  contentType: string;
  deliverableItemId: string;
  fileExt: string;
  partCnt: number;
}

export interface InitFacebookAuthInput {
  redirectUrl: string;
}

export interface InitInstagramAuthInput {
  redirectUrl: string;
}

export interface InitStreamMultipartUploadInput {
  contentType: string;
  fileExt: string;
  partCnt: number;
}

export interface InitTiktokAuthInput {
  redirectUrl: string;
}

export interface InitTiktokIntegrationAuthInput {
  redirectUrl: string;
}

export interface InitVideoPostMultipartUploadInput {
  contentType: string;
  fileExt: string;
  mediaPostId?: string | null;
  partCnt: number;
}

export interface IsUserFollowingStoreInput {
  storeId: string;
}

export interface JoinTicketEventInput {
  invite: string;
  ticketEventId: string;
}

export interface MemorabiliaFilterInput {
  auctionStatuses?: AuctionStatus[] | null;
  createdByRoles?: UserRole[] | null;
  description?: string | null;
  direction?: SortDirection | null;
  fulfillment?: MemorabiliaFulfillment | null;
  id?: string | null;
  ids?: string[] | null;
  isCreatedByAdmin?: boolean | null;
  isMarkedInappropriate?: boolean | null;
  isOrphanPage?: boolean | null;
  limit?: number | null;
  numberOfUnits?: number | null;
  offset?: number | null;
  orderBy?: MemorabiliaOrderBy | null;
  price?: FromToFilter | null;
  productTypes?: MemorabiliaProductType[] | null;
  requestPrice?: FromToFilter | null;
  saleMethods?: MemorabiliaSaleMethod[] | null;
  searchTerm?: string | null;
  sports?: number[] | null;
  statuses?: MemorabiliaStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatuses?: StoreStatus[] | null;
  title?: string | null;
}

export interface MemorabiliaImageInput {
  isMainImage?: boolean | null;
  memorabiliaImageFileKey: string;
}

export interface MerchCustomImageInput {
  imageFileKey: string;
  isMainImage?: boolean | null;
  position?: number | null;
  printfulVariantIds: number[];
}

export interface MerchCustomImageV2Input {
  isMain: boolean;
  key: string;
}

export interface MerchEstimatePrintFileSetInput {
  printFiles: VariantEstimatePrintFileInput[];
  variantSetIndices: number[];
}

export interface MerchProductColor {
  color?: string | null;
  colorCode?: string | null;
  colorCode2?: string | null;
}

export interface MerchProductCustomImageSetInput {
  customImages?: MerchCustomImageV2Input[] | null;
  variantSetIndices: number[];
}

export interface MerchProductPrintFileSetInput {
  printFiles: VariantPrintFileInput[];
  variantSetIndices: number[];
}

export interface MerchProductVariantSet {
  age: Age;
  gender: Gender;
  stitches?: string | null;
  threads?: string[] | null;
  variantIds: number[];
}

export interface MyDashboardFilter {
  from?: any | null;
  to?: any | null;
}

export interface MySalesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamOrderSalesOrderBy | null;
  storeId?: string | null;
}

export interface MyStreamAffiliateLinkSalesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  linkId: string;
  offset?: number | null;
  orderBy?: MyStreamAffiliateSalesOrderBy | null;
}

export interface MyStreamAffiliateLinksInput {
  activity?: MyStreamAffiliateLinkActivity | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MyStreamAffiliateLinksOrderBy | null;
  search?: string | null;
}

export interface MyStreamsFilterInput {
  accountTypes?: AccountType[] | null;
  direction?: SortDirection | null;
  haveSponsor?: boolean | null;
  id?: string | null;
  ids?: string[] | null;
  isPPV?: boolean | null;
  isPersonalized?: boolean | null;
  limit?: number | null;
  moderatorId?: string | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamOrderBy | null;
  ppvStreamId?: string | null;
  price?: FromToFilter | null;
  priceCategories?: StreamPriceCategory[] | null;
  publicStreamCategory?: PublicStreamCategory[] | null;
  scheduleDate?: FromToDatesFilter | null;
  searchTerm?: string | null;
  slug?: string | null;
  sportIds?: number[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatus?: StoreStatus | null;
  streamStatus?: StreamStatus[] | null;
  streamSubtypeFilter?: StreamSubtypeFilter[] | null;
  tzcodes?: string[] | null;
  withCopies?: boolean | null;
  withDeleted?: boolean | null;
}

export interface MyTicketOrdersInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  statuses?: TicketOrderStatus[] | null;
}

export interface MyTicketsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  ticketOrderId?: string | null;
}

export interface OutcomingStreamInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamOrderSortBy | null;
}

export interface PasswordResetInput {
  password: string;
  passwordResetToken: string;
}

export interface PastAppearanceStreamInput {
  description: string;
  hashtagInputs?: HashtagInput[] | null;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  records: AppearanceStreamRecordInput[];
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  timeZone?: TimeZoneInput | null;
}

export interface PlaceBidInput {
  addressId?: string | null;
  amount: number;
  auctionId: string;
}

export interface PrintImageInput {
  printImageId: string;
  userId?: string | null;
}

export interface PrintImageUploadInput {
  designRequestId?: string | null;
  image: any;
  userId?: string | null;
}

export interface ProductPriceEstimateInput {
  changedStock?: number | null;
  fulfillment?: MemorabiliaFulfillment | null;
  numberOfUnits?: number | null;
  ownerId?: string | null;
  productId?: string | null;
  requestedPrice: number;
}

export interface ProductPrintFileEditInputType {
  image?: string | null;
  placementType: PlacementTypes;
  printFilePlacements: ProductPrintFilePlacementInput[];
}

export interface ProductPrintFileInput {
  image: string;
  placementType: PlacementTypes;
  printFilePlacements: ProductPrintFilePlacementInput[];
}

export interface ProductPrintFilePlacementInput {
  angle: number;
  left: number;
  printImageId: string;
  rotatedLeft: number;
  rotatedTop: number;
  scaleX: number;
  scaleY: number;
  top: number;
}

export interface QuestionInputData {
  answerS3Key?: string | null;
  generatedQuestionId?: string | null;
  isCustom: boolean;
  originalVideoKey?: string | null;
  questionText: string;
  topicGroup?: InterviewQuestionTopic | null;
  topicName?: string | null;
  videoTranscodingJobId?: string | null;
}

export interface RecoverMemorabiliaInput {
  id: string;
  storeId?: string | null;
}

export interface RecoverStoreExperienceInput {
  id: string;
}

export interface RedeemTalentInviteLinkInput {
  code: string;
  isNewSignUp: boolean;
}

export interface RefreshTokensInput {
  refreshToken: string;
}

export interface RegenerateStreamAffiliateLinkInput {
  linkId: string;
}

export interface RejectAiClipCandidateInput {
  candidateId: string;
  ownerId?: string | null;
}

export interface RejectEntireOfferInput {
  offerId: string;
}

export interface RejectInterviewAnswerInput {
  videoId: string;
}

export interface RemoveMerchCartItem {
  memorabiliaId?: string | null;
  variantId?: number | null;
}

export interface RemoveMerchCartItemInput {
  items: RemoveMerchCartItem[];
}

export interface RemoveStreamParticipantInput {
  streamId: string;
  userId: string;
}

export interface RemoveTicketEventParticipantInput {
  ticketEventId: string;
  userId: string;
}

export interface RequestCbTaskExtensionInput {
  deliverableId: string;
  eventDate?: any | null;
  reason: string;
  requestedExtensionDays?: number | null;
  type: TaskExtensionRequestType;
}

export interface RequestHelpInputEmail {
  message?: string | null;
  streamId: string;
}

export interface RescheduleTicketEventInput {
  admissionClosesAt: any;
  doorsOpenAt: any;
  endsAt: any;
  expectedVersion: number;
  salesCloseAt: any;
  salesOpenAt?: any | null;
  startsAt: any;
  ticketEventId: string;
}

export interface ReviewActionVideoEditRequestInput {
  editedVideoId: string;
  feedback?: string | null;
  storeId?: string | null;
  videoEditRequestId: string;
}

export interface ScheduleAvailabilityIntervalInput {
  from: string;
  to: string;
}

export interface ScheduleDateAvailabilityInput {
  date: string;
  intervals: ScheduleAvailabilityIntervalInput[];
}

export interface ScheduleDateInput {
  at: any;
  offset?: number | null;
  tzCode?: string | null;
}

export interface ScheduleInterviewAttemptInput {
  interviewId: string;
}

export interface ScheduleWeekDayAvailabilityInput {
  intervals: ScheduleAvailabilityIntervalInput[];
  weekday: WeekDay;
}

export interface ScheduledPostDateV2Input {
  tz?: string | null;
  utc: any;
}

export interface SendEmailVerificationInput {
  email: string;
}

export interface SendManualStoreInterviewInviteInput {
  intervieweeId: string;
}

export interface SendMatchupInviteInput {
  email?: string | null;
  inviteToken: string;
  name: string;
  phone?: string | null;
}

export interface SendOtpInput {
  phoneNumber: string;
  referenceId: string;
}

export interface SendRtmpCredentialsInput {
  streamId: string;
}

export interface SetBrandDealSettingsInput {
  contactEmail?: string | null;
  contactPhone?: string | null;
  disabledCategories?: string[] | null;
  isAcceptAll?: boolean | null;
  isAcceptingFreeProducts?: boolean | null;
  isArticlesPrEnabled?: boolean | null;
  minBookMePrice?: number | null;
  minFlatPrice?: number | null;
  minSocialPrice?: number | null;
  minSocialSharePrice?: number | null;
  minSponsoredLivePrice?: number | null;
  ownerId?: string | null;
}

export interface SetInterviewFeedbackInput {
  feedback?: string | null;
  id: string;
  rate?: number | null;
}

export interface SetMyScheduleInput {
  dates?: ScheduleDateAvailabilityInput[] | null;
  durationMinutes?: number | null;
  minimumNoticeMinutes?: number | null;
  slotStepMinutes?: number | null;
  timezone?: string | null;
  type?: ScheduleType | null;
  weekdays?: ScheduleWeekDayAvailabilityInput[] | null;
}

export interface SetProductSuborderShippedInput {
  suborderId: string;
}

export interface SetScheduleInput {
  dates?: ScheduleDateAvailabilityInput[] | null;
  durationMinutes?: number | null;
  minimumNoticeMinutes?: number | null;
  slotStepMinutes?: number | null;
  timezone?: string | null;
  type?: ScheduleType | null;
  userId: string;
  weekdays?: ScheduleWeekDayAvailabilityInput[] | null;
}

export interface SetStreamAffiliateLinkCommissionInput {
  commissionPercent: number;
  linkId: string;
}

export interface SetStreamAffiliateLinkStatusInput {
  linkId: string;
  status: StreamAffiliateLinkStatus;
}

export interface SetTicketEventMatchupsInput {
  matchups: CreateMatchupInput[];
  ticketEventId: string;
}

export interface SetTicketSaleStatusInput {
  expectedVersion: number;
  status: TicketEventStatus;
  ticketEventId: string;
}

export interface SignInInput {
  email: string;
  password: string;
}

export interface SignOutInput {
  refreshToken: string;
}

export interface SignUpBasicDetailsInput {
  avatarKey?: string | null;
  email: string;
  emailOtpVerificationId?: string | null;
  firstName: string;
  lastName: string;
  password?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  socialSessionToken?: string | null;
  username?: string | null;
}

export interface SignUpGuestV2Input {
  email: string;
}

export interface SignUpV2Input {
  basic: SignUpBasicDetailsInput;
  source?: SignupSourceInput | null;
}

export interface SignupSourceExtraInput {
  campaignId?: string | null;
  contactId?: string | null;
  type: SignUpSource;
}

export interface SignupSourceInput {
  domain?: string | null;
  extra?: SignupSourceExtraInput | null;
  signUpSource: SignUpSource;
  signUpSourceId?: string | null;
  signUpSourceRequestId?: string | null;
}

export interface SocialAccountInput {
  link: string;
  platform: SocialMediaType;
}

export interface StartCampaignOfferAgreementInput {
  addressId?: string | null;
  answers?: CbApplicationAnswersInput[] | null;
  counterAmount?: number | null;
  counterMessage?: string | null;
  offerId: string;
}

export interface StartStreamInput {
  dimensions?: DimensionsInput | null;
  id: string;
}

export interface StoreDetailsInput {
  athleticLevel?: StoreAthleticLevel | null;
  avatar?: any | null;
  avatarFileKey?: string | null;
  bio?: string | null;
  birthDate?: string | null;
  bitcoinReceivingAddress?: string | null;
  careerStatus?: StoreCareerStatus | null;
  city?: string | null;
  collegeId?: string | null;
  country?: string | null;
  cover?: any | null;
  coverVideoKey?: string | null;
  description?: string | null;
  facebookFollowing?: number | null;
  facebookLink?: string | null;
  favoriteNumber?: number | null;
  gender?: StoreGender | null;
  gymRole?: string | null;
  hometown?: string | null;
  hometownCountry?: string | null;
  hometownLocation?: EarthCoordinateInput | null;
  hometownState?: string | null;
  instagramFollowing?: number | null;
  instagramLink?: string | null;
  isBirthDayKnown?: boolean | null;
  isBirthMonthKnown?: boolean | null;
  leagueId?: string | null;
  location?: EarthCoordinateInput | null;
  organizationType?: OrganizationType | null;
  otherCollege?: string | null;
  otherLeague?: string | null;
  otherTeam?: string | null;
  signUpFlow?: SignUpFlow | null;
  socialMediaLink?: string | null;
  state?: string | null;
  storeName?: string | null;
  storeTitle?: string | null;
  subtype?: AccountSubType | null;
  teamId?: string | null;
  tiktokFollowing?: number | null;
  tiktokLink?: string | null;
  twitterFollowing?: number | null;
  twitterLink?: string | null;
  website?: string | null;
  youtubeFollowing?: number | null;
  youtubeLink?: string | null;
}

export interface StoreEditInput {
  storeDetails?: StoreDetailsInput | null;
  storeId?: string | null;
  userDetails?: UserDetailsInput | null;
}

export interface StoreGetInput {
  id?: string | null;
  slug?: string | null;
}

export interface StoreImageInput {
  id?: string | null;
  image: any;
}

export interface StoreRejectMerchDesignInput {
  designRequestId: string;
  feedback: string;
}

export interface StoresByHashtagInput {
  direction?: SortDirection | null;
  hashtagId?: number | null;
  hashtagName?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StoresOrderBy | null;
  status?: StoreStatus | null;
  storeRoles?: UserRole[] | null;
}

export interface StoresFilterInput {
  areaOfInfluenceIds?: string[] | null;
  direction?: SortDirection | null;
  hasActiveAma?: boolean | null;
  hasActiveExperiences?: boolean | null;
  hasActiveMerch?: boolean | null;
  hasActiveProducts?: boolean | null;
  hasActiveStreams?: boolean | null;
  hasAreaOfInfluence?: boolean | null;
  hasBirthDate?: boolean | null;
  hasContent?: boolean | null;
  hasPsychosocialKeywords?: boolean | null;
  hashtagIds?: number[] | null;
  id?: string | null;
  isShoppingEnabled?: boolean | null;
  isStreamer?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StoresOrderBy | null;
  psychosocialKeywordsIds?: string[] | null;
  searchTerm?: string | null;
  slug?: string | null;
  sportId?: number | null;
  sports?: number[] | null;
  status?: StoreStatus[] | null;
  storeIds?: string[] | null;
  storeName?: string | null;
}

export interface StreamAffiliateLinksInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamAffiliateLinksOrderBy | null;
  status?: StreamAffiliateLinkStatus | null;
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamAffiliateStreamInput {
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamCreateInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  image?: any | null;
  imageFileKey?: string | null;
  isFree?: boolean | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  price?: number | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  requestedPrice?: number | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  timeZone?: TimeZoneInput | null;
}

export interface StreamCreateSponsorsInput {
  id?: string | null;
  imageFile?: any | null;
  imageFileKey?: string | null;
  logo?: string | null;
  name: string;
  promoMessage?: string | null;
}

export interface StreamEventAnalyticsInput {
  streamId: string;
}

export interface StreamFilterInput {
  accountTypes?: AccountType[] | null;
  direction?: SortDirection | null;
  haveSponsor?: boolean | null;
  id?: string | null;
  ids?: string[] | null;
  isPPV?: boolean | null;
  isPersonalized?: boolean | null;
  limit?: number | null;
  moderatorId?: string | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamOrderBy | null;
  ppvStreamId?: string | null;
  price?: FromToFilter | null;
  priceCategories?: StreamPriceCategory[] | null;
  publicStreamCategory?: PublicStreamCategory[] | null;
  scheduleDate?: FromToDatesFilter | null;
  searchTerm?: string | null;
  slug?: string | null;
  sportIds?: number[] | null;
  storeId?: string | null;
  storeIds?: string[] | null;
  storeName?: string | null;
  storeSlug?: string | null;
  storeStatus?: StoreStatus | null;
  streamStatus?: StreamStatus[] | null;
  streamSubtypeFilter?: StreamSubtypeFilter[] | null;
  tzcodes?: string[] | null;
  withCopies?: boolean | null;
  withDeleted?: boolean | null;
}

export interface StreamImageItemInput {
  contentType: string;
  ext: string;
}

export interface StreamNoteCreateInput {
  note: string;
  relativeTs?: number | null;
  streamId: string;
  streamRecordId?: number | null;
}

export interface StreamOrderAndTipsTypeInput {
  customerEmail?: string | null;
  customerName?: string | null;
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: MyTipsAndOrdersSalesOrderBy | null;
  paidAtDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
}

export interface StreamOrderCreateInput {
  affiliateCode?: string | null;
  billingAddressId?: string | null;
  keepIntent?: boolean | null;
  promocodeId?: string | null;
  streamId: string;
}

export interface StreamParticipantFilterInput {
  direction?: SortDirection | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: StreamParticipantsOrderBy | null;
  status?: StoreStatus[] | null;
  streamId: string;
}

export interface StreamParticipantInviteInput {
  streamId: string;
}

export interface StreamParticipantRowsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  statuses?: StreamParticipantRowStatus[] | null;
  streamId?: string | null;
  ticketEventId?: string | null;
}

export interface StreamSalesInput {
  direction?: SortDirection | null;
  limit?: number | null;
  name?: string | null;
  offset?: number | null;
  orderBy?: StreamSalesOrderBy | null;
  scheduledDateRange?: FromToDatesFilter | null;
  storeId?: string | null;
  storeName?: string | null;
}

export interface StreamTipBitcoinCreateInput {
  amount: number;
  fiat_currency?: string | null;
  message?: string | null;
  ownerId?: string | null;
  streamId: string;
  termsOfServiceOptIn?: boolean | null;
}

export interface StreamTipCreateInput {
  amount: number;
  message?: string | null;
  streamId: string;
  termsOfServiceOptIn?: boolean | null;
}

export interface StreamUpdateInput {
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  chatEnabled?: boolean | null;
  description: string;
  fanPollingEnabled?: boolean | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  image?: any | null;
  imageFileKey?: string | null;
  isHidden?: boolean | null;
  isPPV?: boolean | null;
  matchups?: CreateMatchupInput[] | null;
  mentionsInputs?: CreateMentionInput[] | null;
  moderatorId?: string | null;
  name?: string | null;
  participantIds?: string[] | null;
  postEventContentHubEnabled?: boolean | null;
  repeatingTitle?: string | null;
  repeatsEveryEnum?: StreamIntervalEnum | null;
  scheduleDate?: any | null;
  scheduleDateV2?: DateV2Input | null;
  sharePickGraphicsEnabled?: boolean | null;
  sponsors?: StreamCreateSponsorsInput[] | null;
  sportIds?: number[] | null;
  timeZone?: TimeZoneInput | null;
}

export interface SubmitCampaignDeliverableItemV2Input {
  copy?: string | null;
  deliverableItemId: string;
  files?: SubmitCampaignDeliverableUploadedFileInput[] | null;
  key?: string | null;
  link?: string | null;
  name?: string | null;
  type: CBDeliverableItemType;
  videoTranscodingJobId?: string | null;
}

export interface SubmitCampaignDeliverableUploadedFileInput {
  key: string;
  name: string;
  type: CampaignMediaType;
  videoTranscodingJobId?: string | null;
}

export interface SubmitCampaignDeliverablesForReviewInput {
  files?: DeliverableFileInput[] | null;
  items?: DeliverableItemInput[] | null;
  offerId: string;
  ownerId?: string | null;
  postCopy?: string | null;
}

export interface SubmitCampaignDeliverablesForReviewV2Input {
  items: SubmitCampaignDeliverableItemV2Input[];
  offerId: string;
  ownerId?: string | null;
}

export interface SubmitCampaignOfferResultsInput {
  offerId: string;
  ownerId?: string | null;
  submissions?: CampaignOfferSubmissionInput[] | null;
}

export interface SuggestUsernameInput {
  firstName: string;
  lastName: string;
  profileName?: string | null;
  subtype?: AccountSubType | null;
}

export interface SwitchToCreatorInput {
  avatarKey?: string | null;
  bio?: string | null;
  birthDate?: string | null;
  city?: string | null;
  country?: string | null;
  emailOtpVerificationId?: string | null;
  gender?: StoreGender | null;
  level?: StoreAthleticLevel | null;
  location?: EarthCoordinateInput | null;
  ownerId?: string | null;
  phoneNumberE164: string;
  phoneOptIn: boolean;
  phoneOtpVerificationId?: string | null;
  profileName: string;
  socialAccounts?: SocialAccountInput[] | null;
  sportIds: number[];
  state?: string | null;
  subtype: AccountSubType;
  username: string;
}

export interface TicketAvailabilityInput {
  ticketEventId: string;
}

export interface TicketEventImageUploadInput {
  files: StreamImageItemInput[];
}

/**
 * Exactly one of id and slug.
 */
export interface TicketEventLookupInput {
  id?: string | null;
  slug?: string | null;
}

export interface TicketEventOrdersInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: TicketEventOrderSort | null;
  statuses?: TicketOrderStatus[] | null;
  ticketEventId: string;
  kinds?: TicketOrderKind[] | null;
}

export interface TicketEventSalesSummariesInput {
  ticketEventIds: string[];
}

export interface TicketEventsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: TicketEventsOrderBy | null;
  priceFrom?: number | null;
  priceTo?: number | null;
  searchTerm?: string | null;
  standaloneOnly?: boolean | null;
  startsFrom?: any | null;
  startsTo?: any | null;
  storeIds?: string[] | null;
  ticketsOnly?: boolean | null;
  timings?: TicketEventTiming[] | null;
}

export interface TicketHoldItemInput {
  quantity: number;
  tierId: string;
}

export interface TicketOrderInput {
  id: string;
}

export interface TicketQrInput {
  ticketId: string;
}

export interface TicketTierDetailsInput {
  capacity: number;
  description?: string | null;
  label: string;
  maxPerOrder?: number | null;
  price: number;
  salesCloseAt?: any | null;
  salesOpenAt?: any | null;
}

export interface TicketTransferInvitationInput {
  secret: string;
  transferId: string;
}

export interface TicketVenueDetailsInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  name: string;
  postalCode: string;
  region: string;
  timezone: string;
}

export interface TicketVenuePlacePredictionsInput {
  query: string;
  sessionToken?: string | null;
}

export interface TikTokV2AuthInput {
  code: string;
  redirectUrl: string;
}

export interface TimeZoneInput {
  offset?: number | null;
  tzCode?: string | null;
}

export interface TipListInput {
  direction?: SortDirection | null;
  limit?: number | null;
  message?: string | null;
  offset?: number | null;
  orderBy?: TipOrderBy | null;
  orderStatus?: TipStatus[] | null;
  ownerId?: string | null;
}

export interface TrackExtTalentCtaClickInput {
  actionId?: string | null;
  campaign?: string | null;
  campaignId: string;
  contactId?: string | null;
  extTalentId: string;
}

export interface TrackPersonMentionPageVisitInput {
  mentionId: string;
  requestId?: string | null;
}

export interface TrackShareInput {
  shareTarget: TrackedShareTarget;
  sourceId: string;
  sourceType: TrackedSourceType;
}

export interface TransferTicketInput {
  recipientEmail: string;
  ticketId: string;
}

export interface TriggerMatchupSharePickInput {
  matchupId: string;
  votedCompetitorId: string;
}

export interface TwitterAuthInput {
  oauth_token: string;
  oauth_verifier: string;
}

export interface UnfollowStoresInput {
  storeIds: string[];
}

export interface UnhideStreamInput {
  id: string;
}

export interface UnlinkSocialMediaConnectionInput {
  provider: SocialMediaConnectionProvider;
  username: string;
}

export interface UpcomingInterviewsInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  statuses?: InterviewStatus[] | null;
}

export interface UpdateAddressInput {
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  company?: string | null;
  country?: string | null;
  countryCode?: string | null;
  email?: string | null;
  firstName?: string | null;
  id: string;
  isDefault?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  phoneNumberE164?: string | null;
  state?: string | null;
  stateCode?: string | null;
  zipCode?: string | null;
}

export interface UpdateInterviewInfoInput {
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  imageFileKey?: string | null;
  mentionsInputs?: CreateMentionInput[] | null;
  name?: string | null;
  notes?: string | null;
  scheduledMeetingLink?: string | null;
}

export interface UpdateMemorabiliaInput {
  addressId?: string | null;
  auctionDateRange?: AuctionFromToInput | null;
  changedStock?: number | null;
  comment?: string | null;
  customsDescription?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  height?: number | null;
  id: string;
  images: MemorabiliaImageInput[];
  length?: number | null;
  requestedPrice: number;
  shipmentCategory: string;
  storeId: string;
  title: string;
  weight?: number | null;
  width?: number | null;
}

export interface UpdateMerchProductInput {
  customImages?: MerchCustomImageInput[] | null;
  hashtagInputs?: HashtagInput[] | null;
  id: number;
  printfulVariantIds?: number[] | null;
  productPrintFiles?: ProductPrintFileEditInputType[] | null;
  requestedProfit: number;
  stitches?: string | null;
  storeId?: string | null;
  threads?: string | null;
  title: string;
}

export interface UpdateStoreExperienceInput {
  comment?: string | null;
  description?: string | null;
  hashtagInputs?: HashtagInput[] | null;
  id: string;
  images: ExperienceImageInput[];
  numberOfUnits?: number | null;
  requestedPrice: number;
  title: string;
}

export interface UpdateTicketEventDetailsInput {
  coverImageFileKey?: string | null;
  description?: string | null;
  entryRequirements?: string | null;
  expectedVersion: number;
  hashtagInputs?: HashtagInput[] | null;
  leagueId?: string | null;
  maxAdmissions?: number | null;
  minimumAge?: number | null;
  name?: string | null;
  promotion?: string | null;
  refundPolicy?: string | null;
  repeatsEvery?: StreamIntervalEnum | null;
  sportIds?: number[] | null;
  termsAndConditions?: string | null;
  ticketEventId: string;
  ticketsEnabled?: boolean | null;
  venueId?: string | null;
  affiliateCommissionPercent?: number | null;
  affiliateEnabled?: boolean | null;
  fanPollingEnabled?: boolean | null;
}

export interface UpdateTicketVenueInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  name: string;
  postalCode: string;
  region: string;
  timezone: string;
  ticketEventId: string;
}

export interface UpsertEventDirectChannelInput {
  eventId: string;
  eventType: EventChatSourceType;
  participantUserId: string;
}

export interface UserDetailsInput {
  areaOfInfluenceIds?: string[] | null;
  email?: string | null;
  emailOtpVerificationId?: string | null;
  firstName?: string | null;
  hashtagIds?: number[] | null;
  hashtagInputs?: HashtagInput[] | null;
  influencerCategoryIds?: number[] | null;
  isForBrandDealsOnly?: boolean | null;
  isOrphanPage?: boolean | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  psychosocialKeywordsIds?: string[] | null;
  redirects?: string[] | null;
  sportIds?: number[] | null;
  username?: string | null;
}

export interface UserTipBitcoinCreateInput {
  amount: number;
  fiat_currency?: string | null;
  message?: string | null;
  ownerId?: string | null;
  recipientId: string;
  termsOfServiceOptIn?: boolean | null;
}

export interface UserTipCreateInput {
  amount: number;
  message?: string | null;
  recipientId: string;
  termsOfServiceOptIn?: boolean | null;
}

export interface UserUpdateInput {
  avatarKey?: string | null;
  email?: string | null;
  emailOtpVerificationId?: string | null;
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberE164?: string | null;
  phoneOptIn?: boolean | null;
  phoneOtpVerificationId?: string | null;
  username?: string | null;
}

export interface VariantEstimatePrintFileInput {
  placementType: PlacementTypes;
}

export interface VariantPrintFileInput {
  key: string;
  placementType: PlacementTypes;
  printFilePlacements: ProductPrintFilePlacementInput[];
}

export interface VariantPrintfilePresignedUrlInput {
  contentType: string;
  ext: string;
}

export interface VerifyEmailInput {
  code: string;
  email: string;
}

export interface VerifyOtpInput {
  code: string;
  phoneNumber: string;
  referenceId: string;
}

export interface VideoCroppedArea {
  height: number;
  width: number;
  x: number;
  y: number;
  zoom: number;
}

export interface VideoCroppedInput {
  area?: VideoCroppedArea | null;
  file: any;
  type?: string | null;
}

export interface VideoEditRequestsStoreFilterInput {
  direction?: SortDirection | null;
  limit?: number | null;
  offset?: number | null;
  orderBy?: VideoEditRequestsStoreOrderBy | null;
  statuses?: VideoEditRequestStatus[] | null;
  storeId?: string | null;
}

export interface VoteMatchupInput {
  competitorId: string;
  matchupId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
